'use client';

import { Flex, Skeleton, SkeletonText } from '@skin-seoul/design-system';
const ProductFinderSelectSkeleton = () => {
  return <Flex flexDirection="column" justifyContent="space-between" alignItems="flex-start" gap={{
    base: 6,
    desktop: 4
  }} width="100%" data-sentry-element="Flex" data-sentry-component="ProductFinderSelectSkeleton" data-sentry-source-file="ProductFinderSkeleton.tsx">
      <SkeletonText width="30%" height="20px" noOfLines={1} data-sentry-element="SkeletonText" data-sentry-source-file="ProductFinderSkeleton.tsx" />
      <Skeleton height="40px" width="100%" data-sentry-element="Skeleton" data-sentry-source-file="ProductFinderSkeleton.tsx" />
    </Flex>;
};
const ProductFinderSkeleton = () => {
  return <>
      <Flex direction={{
      base: 'column',
      desktop: 'row'
    }} gap={{
      base: 12,
      desktop: 16
    }} width="100%" data-sentry-element="Flex" data-sentry-source-file="ProductFinderSkeleton.tsx">
        <ProductFinderSelectSkeleton data-sentry-element="ProductFinderSelectSkeleton" data-sentry-source-file="ProductFinderSkeleton.tsx" />
        <ProductFinderSelectSkeleton data-sentry-element="ProductFinderSelectSkeleton" data-sentry-source-file="ProductFinderSkeleton.tsx" />
        <ProductFinderSelectSkeleton data-sentry-element="ProductFinderSelectSkeleton" data-sentry-source-file="ProductFinderSkeleton.tsx" />
      </Flex>

      <Skeleton height="48px" width={{
      base: '100%',
      tablet: '332px'
    }} alignSelf="center" borderRadius="8px" data-sentry-element="Skeleton" data-sentry-source-file="ProductFinderSkeleton.tsx" />
    </>;
};
export default ProductFinderSkeleton;